"use client";

import { Hero } from "./hero";
import { MissionStatement } from "./mission-statement";
import { Problem } from "./problem";
import { Vision } from "./vision";
import { Goals } from "./goals";
import { Impact } from "./impact";
import { HowWeDeliver } from "./how-we-deliver";
import { EthicalFramework } from "./ethical-framework";
import { TechnologyMission } from "./technology-mission";
import { ClientCommitment } from "./client-commitment";
import { SecurityCommitment } from "./security-commitment";
import { IndustryImpactMission } from "./industry-impact";
import { People } from "./people";
import { Community } from "./community";
import { LongTermVision } from "./long-term-vision";
import { SuccessMetrics } from "./success-metrics";
import { Partnership } from "./partnership";
import { GlobalCommitment } from "./global-commitment";
import { Sustainable } from "./sustainable";
import { MissionCta } from "./cta";

export function MissionPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <MissionStatement />
      </div>
      <Problem />
      <div className="bg-aurora-cyan">
        <Vision />
      </div>
      <Goals />
      <div className="bg-aurora-emerald">
        <Impact />
      </div>
      <HowWeDeliver />
      <div className="bg-aurora-amber">
        <EthicalFramework />
      </div>
      <TechnologyMission />
      <div className="bg-aurora-purple">
        <ClientCommitment />
      </div>
      <SecurityCommitment />
      <div className="bg-aurora-cyan">
        <IndustryImpactMission />
      </div>
      <People />
      <div className="bg-aurora-emerald">
        <Community />
      </div>
      <LongTermVision />
      <div className="bg-aurora-amber">
        <SuccessMetrics />
      </div>
      <Partnership />
      <div className="bg-aurora-purple">
        <GlobalCommitment />
      </div>
      <Sustainable />
      <MissionCta />
    </>
  );
}
